const DRAWER = {
    WIDTH : 400,
}

export { 
    DRAWER , 
};